import type {
  DocumentTab,
  SearchHistoryItem,
} from 'features/knowledgeDocumentViewer/types'

/** Chat/search entry to keep mounted when this tab has navigated to a document. */
export function getKeepAliveSearchHistoryEntry(
  tab: DocumentTab
): { item: SearchHistoryItem; index: number } | undefined {
  for (let index = tab.currentIndex; index >= 0; index -= 1) {
    const item = tab.history[index]
    if (item?.type === 'search') return { item, index }
  }
  return undefined
}

export function isSearchTabVisible(
  tab: DocumentTab,
  activeTabId: string
): boolean {
  return (
    tab.id === activeTabId && tab.history[tab.currentIndex]?.type === 'search'
  )
}

/** Visited chats stay mounted for the life of the tab so Back can restore scroll. */
export function nextMountedSearchTabIds(
  previouslyMounted: ReadonlySet<string>,
  openTabIds: ReadonlySet<string>,
  activeSearchTabId: string | undefined
): Set<string> {
  const next = new Set(
    [...previouslyMounted].filter((tabId) => openTabIds.has(tabId))
  )
  if (activeSearchTabId) next.add(activeSearchTabId)
  return next
}
